import { memo, useCallback } from 'react';
import { QuantityControlInput } from '../../../../../../../../../../components/QuantityControlInput';
import { SelloutDistributionQuantityInputProps } from '../types/selloutDistributionQuantityInput.types';
import SelloutDistributionQuantityInputTextField from './SelloutDistributionQuantityInputTextfield';

interface SelloutDistributionTouchQuantityInputProps
  extends SelloutDistributionQuantityInputProps {}

const SelloutDistributionTouchQuantityInput = ({
  pieces,
  disabled,
  onChangePieces,
}: SelloutDistributionTouchQuantityInputProps) => {
  const onClickIncrement = useCallback(() => {
    pieces >= 0 && onChangePieces(pieces + 1);
  }, [pieces, onChangePieces]);

  const onClickDecrement = useCallback(() => {
    pieces >= 1 && onChangePieces(pieces - 1);
  }, [pieces, onChangePieces]);

  return (
    <QuantityControlInput
      onDecrement={onClickDecrement}
      onIncrement={onClickIncrement}
      disabled={disabled}
      Input={
        <SelloutDistributionQuantityInputTextField
          pieces={pieces}
          disabled={disabled}
          onChangePieces={onChangePieces}
        />
      }
    />
  );
};

export default memo(SelloutDistributionTouchQuantityInput);
